import { render, staticRenderFns } from "./ProfessionalDevelopment.vue?vue&type=template&id=fcc89238&"
import script from "./ProfessionalDevelopment.vue?vue&type=script&lang=js&"
export * from "./ProfessionalDevelopment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports